<template>
  <div>
    <v-switch
      label="Al autorizar esta plantilla, esta podrá ser utilizada en una llamada por el operador."
      v-model="data"
      class="k-blue-linear-text"
      :hide-details="true">
    </v-switch>
    <small>Al autorizar esta plantilla, esta podrá ser utilizada en una llamada por el operador.</small>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      data: false,
    };
  },
  watch: {
    value(val) {
      if (this.data !== val) {
        this.data = val;
      }
    },
    data(val) {
      this.$emit('input', val);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/AnswerTemplateSwitch.vue